<template>
  <div class="editorial-container" :class="{ shown: visible }">
    <div class="content">
      <div class="top">
        <h1 v-if="beatData.copyTitle" class="copy-title" v-html="beatData.copyTitle"></h1>
        <div v-if="beatData.media" class="media" :style="`background-image: url(${beatData.media})`"></div>
      </div>
      <div v-if="beatData.copy" class="bottom">
        <p v-html="beatData.copy"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    beatData: {
      type: Object,
      default: () => {}
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/style/_variables';
@import '@/assets/style/_fonts';

.editorial-container {
  position: relative;
  height: 100%;
  height: -webkit-fill-available;
  .content {
    @include center-in-parent;
    width: 100%;
  }
  .top {
    margin-bottom: $space-s;
    display: flex;
    @include media($bp-tablet) {
      flex-wrap: wrap;
    }
    h1 {
      text-transform: uppercase;
      font-size: 30vh;
      line-height: 1.05em;
      white-space: nowrap;

      @include media($bp-desktop-xl) {
        font-size: 25vh;
      }
      @include media($bp-desktop-l) {
        font-size: 20vh;
      }
      @include media($bp-desktop-s) {
        font-size: 15vh;
      }
      @include media($bp-phone-l) {
        // font-size: $font-size-xxl;
        font-size: 33vw;
      }
    }
    .media {
      @include bg-cover-center;
      margin-left: $space-m;
      min-width: 300px;
      min-height: 15vh;
      flex-grow: 1;

      @include media($bp-desktop-l) {
        min-width: 200px;
      }
      @include media($bp-tablet) {
        min-width: 100%;
        margin-left: 0;
        min-height: 30vh;
      }
    }
  }
  .bottom {
    p {
      font-size: $font-size-l;
      line-height: 1.05em;
      @include media($bp-desktop-l) {
        font-size: $font-size-ml;
      }
      @include media($bp-tablet) {
        font-size: $font-size-m;
      }
    }
  }
}
</style>
